// FT-217 REQ-06 / REQ-08: подписи трёх дней «Ближайших дней» — «Сегодня, 23 окт».
// Даты приходят от сервера строкой "YYYY-MM-DD" — настенная дата филиала
// (Company#wall_clock_now), поэтому здесь её не пересчитываем в пояс браузера:
// разбираем как UTC-полночь и печатаем в UTC.

export const UPCOMING_DAY_KEYS = ["day_0", "day_1", "day_2"];

// "2026-10-23" → "23 окт." (по языку интерфейса). Нераспознанная строка — как есть.
export function upcomingDateText(date, locale) {
  if (!date) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(date));
  if (!m) return String(date);
  const value = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  const opts = { day: "numeric", month: "short", timeZone: "UTC" };
  try {
    return new Intl.DateTimeFormat(locale || undefined, opts).format(value);
  } catch (e) {
    return new Intl.DateTimeFormat(undefined, opts).format(value);
  }
}

// index 0..2 → «Сегодня» / «Завтра» / «Послезавтра». Ключи — литералами, а не
// сборкой строки: так их видит реестр динамических ключей (locales/dynamicKeys.spec.js).
const DAY_NAME_KEYS = ["cars_board.upcoming_day_0", "cars_board.upcoming_day_1", "cars_board.upcoming_day_2"];

export function upcomingDayName(index, t) {
  return DAY_NAME_KEYS[index] ? t(DAY_NAME_KEYS[index]) : "";
}

// Заголовок колонки доски: «Сегодня, 23 окт.»; без даты — только название дня.
export function upcomingDayTitle(index, date, { t, locale } = {}) {
  const name = upcomingDayName(index, t);
  const text = upcomingDateText(date, locale);
  return text ? `${name}, ${text}` : name;
}
